import React, { PropsWithChildren } from "react";
import styles from "./styles.module.scss";

const BlueGradientLayout: React.FC<PropsWithChildren> = ({ children }) => {
  return <div className={styles.layout}>{children}</div>;
};

export default BlueGradientLayout;
